"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _componentsWeb = require("@telus-uds/components-web");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _ThemeContext = _interopRequireDefault(require("./ThemeContext"));
var _themes = require("./themes");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
var FormBuilderThemeProvider = _ref => {
  var {
    theme: themeName,
    children
  } = _ref;
  var theme = (0, _themes.getThemeByName)(themeName);
  return /*#__PURE__*/_react.default.createElement(_componentsWeb.BaseProvider, {
    defaultTheme: theme
  }, /*#__PURE__*/_react.default.createElement(_ThemeContext.default.Provider, {
    value: {
      themeName
    }
  }, children));
};
FormBuilderThemeProvider.propTypes = {
  theme: _propTypes.default.oneOf(_themes.AVAILABLE_THEMES)
};
var _default = exports.default = FormBuilderThemeProvider;